/**
 * Sales / POS enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Sale status labels
export const saleStatusLabels = {
    open: 'Open',
    completed: 'Completed',
    refunded: 'Refunded',
    partially_refunded: 'Partially Refunded',
    voided: 'Voided',
};
export const saleStatusValues = Object.keys(saleStatusLabels);
// Sale tip type labels
export const saleTipTypeLabels = {
    none: 'No Tip',
    percent: 'Percentage',
    amount: 'Fixed Amount',
};
export const saleTipTypeValues = Object.keys(saleTipTypeLabels);
// Sale item type labels
export const saleItemTypeLabels = {
    appointment: 'Appointment',
    service: 'Service',
    product: 'Product',
    membership: 'Membership',
    gift_card: 'Gift Card',
    manual: 'Manual payment',
};
export const saleItemTypeValues = Object.keys(saleItemTypeLabels);
// Sale payment method labels.
//
// `deposit` is NOT operator-selectable — the checkout's tender picker runs off
// explicit allowlists, and this one is seeded by `createSaleFromAppointment`
// from an already-paid `appointment_deposit`. It exists as a tender rather than
// a discount so the subtotal stays honest and balance-due arithmetic falls out
// of the existing `sum(succeeded tenders) >= totalCents` rule.
//
// APPENDED, not inserted: `salePaymentMethodValues` is `Object.keys(...)`, so
// position determines the Postgres enum's value order.
export const salePaymentMethodLabels = {
    cash: 'Cash',
    card_terminal: 'Card Terminal',
    qr_self_checkout: 'QR Self-Checkout',
    manual_card: 'Manual Card Entry',
    gift_card: 'Gift Card',
    deposit: 'Deposit',
    saved_card: 'Saved Card',
};
export const salePaymentMethodValues = Object.keys(salePaymentMethodLabels);
// Sale payment status labels
export const salePaymentStatusLabels = {
    pending: 'Pending',
    succeeded: 'Succeeded',
    failed: 'Failed',
    refunded: 'Refunded',
};
export const salePaymentStatusValues = Object.keys(salePaymentStatusLabels);
//# sourceMappingURL=sales.js.map